// BatteryIcon.jsx
import React from 'react'
import battery from "../../Styles/icons/battery.png"
import battery_warning from "../../Styles/icons/battery_warning.png"
import './BatteryIcon.css'
import { useT } from "../../i18n"

const BatteryIcon = ({ level }) => {
  const t = useT()
  const pct = Math.max(0, Math.min(100, level))
  const color = pct > 50 ? '#50FE00' : pct > 20 ? '#ff9800' : '#f44336'
  const battery_image = pct > 50 ? battery : battery_warning

  return (
// BatteryIcon.jsx (순서 바꿔도 되고, z-index로도 가능)
<div className="battery-icon" role="img" aria-label={t("common.battery.aria", { pct })} title={`${pct}%`}>
  <div className="battery-body">
    <div className="battery-level" style={{ width: `${pct}%`, backgroundColor: color }} />
  </div>
  <img src={battery_image} className="battery-outline" alt="" aria-hidden="true" />
</div>

  )
}




export default BatteryIcon